import React from 'react';
import theme from './RoomPill.module.scss';
import { RoomDto } from '@/types';
import { Badge, BadgeSize, BadgeVariant, SimpleTooltip } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';

export interface RoomPillProps {
    room: RoomDto;
    variant?: BadgeVariant;
    size?: BadgeSize;
    pricingFieldName?: string;
}

export const RoomPill: React.FC<RoomPillProps> = ({ room, variant = 'info', size = 'sm', pricingFieldName }) => {
    const note = room.labelNote?.trim();
    const tooltipContent =
        note || pricingFieldName ? (
            <>
                {note && (
                    <div>
                        <Trans>Internal note:</Trans> {note}
                    </div>
                )}
                {pricingFieldName && (
                    <div>
                        <Trans>Pricing variable:</Trans> {pricingFieldName}
                    </div>
                )}
            </>
        ) : null;
    return (
        <SimpleTooltip content={tooltipContent}>
            <Badge variant={variant} iconLeft={room.icon ? ['fal', room.icon] : undefined} size={size} appearance='subtle'>
                {room.name}
                {note && <small className={theme.note}>({note})</small>}
                {pricingFieldName && <small className={theme.pricingField}>· {pricingFieldName}</small>}
            </Badge>
        </SimpleTooltip>
    );
};
